import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import Input from '../../ui/Input';
import CopiedMessage from '../../ui/CopiedMessage';
import { onCopyPassword, onGeneratePassword } from './helpers';
const PasswordFields = ({ refs, formState, formErrors, validateInputField, setUpdatedFormFields, formType, justCopied, setJustCopied, }) => {
    const { t } = useTranslation();
    return (_jsxs("div", { className: "form-group", children: [_jsx("div", { className: `copy-message`, children: _jsx(CopiedMessage, { justCopied: justCopied }) }), _jsx(Input, { type: 'password', ref: refs.password, id: 'password', value: formState.password, name: "password", label: t(formType === 'create' ? 'label.password' : 'label.new_password'), placeholder: t('placeholder.password'), onChange: (event) => {
                    formState.setPassword(event.currentTarget.value);
                    validateInputField({ fieldName: 'password', value: event.currentTarget.value });
                    setUpdatedFormFields((prev) => {
                        const newSet = new Set(prev);
                        newSet.add('password');
                        return newSet;
                    });
                }, error: !!formErrors.password?.length, errorMessage: !!formErrors.password?.length
                    ? t(formErrors.password[0].messageTranslationKey)
                    : undefined, additionalContent: formState.password ? (_jsx("div", { className: "link-button", onClick: async () => await onCopyPassword({ formState, setJustCopied }), tabIndex: 0, onKeyDown: async (event) => {
                        if (event.code === 'Space') {
                            event.preventDefault();
                            await onCopyPassword({ formState, setJustCopied });
                        }
                    }, children: t('button.copy_password') })) : (_jsx("div", { className: "link-button", onClick: () => onGeneratePassword({ formState, validateInputField, setUpdatedFormFields }), tabIndex: 0, onKeyDown: async (event) => {
                        if (event.code === 'Space') {
                            event.preventDefault();
                            onGeneratePassword({ formState, validateInputField, setUpdatedFormFields });
                        }
                    }, children: t('button.generate_password') })) }), _jsx(Input, { type: 'password', ref: refs.confirmPassword, id: 'confirm-password', value: formState.confirmPassword, name: "confirmPpassword", placeholder: t('placeholder.password_confirm'), onChange: (event) => {
                    formState.setConfirmPassword(event.currentTarget.value);
                    validateInputField({ fieldName: 'confirmPassword', value: event.currentTarget.value });
                    setUpdatedFormFields((prev) => {
                        const newSet = new Set(prev);
                        newSet.add('confirmPassword');
                        return newSet;
                    });
                }, error: !!formErrors.confirmPassword?.length, errorMessage: !!formErrors.confirmPassword?.length
                    ? t(formErrors.confirmPassword[0].messageTranslationKey)
                    : undefined })] }));
};
export default PasswordFields;
